import * as React from "react";
/**
 * App Instance context
 */ export const AppInstanceContext = React.createContext({
    appRootElementId: null
});
export const AppInstanceContextProvider = AppInstanceContext.Provider;
